import dsr from "./modules/dsr";
import dsr_details from "./modules/dsr_details";

export default { dsr, dsr_details };
